// css =>
import "../../BaseStructure.css";
import Styled from "./CodeReceive.module.css";

// components =>
import Header from "../../Components/header/header.comp";
import MenuBar from "../../Components/menuBar/menuBar.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";

// react =>
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// hooks =>
import useTimer from "../../hooks/useTimer";
import { useUserStore } from "../../hooks/useUserStore";

// utils =>
import NumberToTimeChanger from "../../utils/TimeFormat";
import { ValidateRequiredFields } from "../../utils/FieldValidation";

// service =>
import { SendOTP, HandleOTPSubmit } from "./CodeReceiveService";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

function CodeReceive() {

    const location = useLocation();
    const navigate = useNavigate();
    const { showMessage } = useMessage();
    const { timeRemaining, startTimer, isTimerRunning } = useTimer(0);
    const authorizationCodeInputRef = useRef<HTMLInputElement | null>(null);
    const { name, lastName, phoneNumber, address, postalCode, emailAddress, gender, actionType } = location.state;

    const otpRequested = useRef(false);

    useEffect(() => {
        document.title = "دریافت کد | ویدوک";
        let cancelled = false;

        const fetchOTP = async () => {
            const now = Date.now();
            const lastSent = localStorage.getItem('otp_last_sent');

            if (!lastSent || now - parseInt(lastSent) > 120000) {
                if (otpRequested.current) return;
                otpRequested.current = true;
    
                    const sendOtpResult = await SendOTP(phoneNumber);
    
                    if (sendOtpResult.success) {
                        localStorage.setItem('otp_last_sent', now.toString());
                        startTimer(120);
                        showMessage("success", sendOtpResult.message);
                        return;
                    }
    
                    showMessage("error", sendOtpResult.message);
    
                    if (cancelled) return;
            }
        };

        fetchOTP();

        return () => { cancelled = true; };
    }, [phoneNumber]);

    const handleSubmit = async () => {
        if (!ValidateRequiredFields((msg) => showMessage("error", msg), authorizationCodeInputRef)) 
            return;

        const result = await HandleOTPSubmit(
            phoneNumber,
            authorizationCodeInputRef.current!.value,
            actionType,
            { name, last_name: lastName, gender: gender, email_address: emailAddress, user_gender: gender, postal_code: postalCode, address }
        );

        if (result.success) {
            useUserStore.getState().setUser(result.data);
            
            if (actionType == "sign-in") {
                navigate("/welcome-sign-in");
            } else {
                navigate("/welcome-log-in");
            }

            return;
        }

        showMessage("error", result.message);
    };

    return(
        <>
            <Header />
            <MobileMenuBar key={ 0 } isAuthenticated={ false } />

            <div className="row" id={ Styled.CodeReceiveBox }>
                <div className="col-12">
                    <div className="col-12">
                        <input type="number" ref={ authorizationCodeInputRef }/>
                    </div>
                </div>
            </div>

            <div className="row" id={ Styled.CodeReceiveButtonBox }>
                <div className={`col-12 ${ Styled.ButtonSection } `}>
                    <button disabled={ isTimerRunning } style={{ backgroundColor: 'rgb(31, 78, 102)' }} onClick={async () => {
                        const result = await SendOTP(phoneNumber);
                        if (result.success) {
                            const now = Date.now();
                            localStorage.setItem('otp_last_sent', now.toString());

                            startTimer(120);
                            showMessage("success", "کد با موفقیت ارسال شد!");
                        } else {
                            showMessage("error", result.message);
                        }
                    }}>
                        <p>{ isTimerRunning ? `${ NumberToTimeChanger(timeRemaining)}` : 'ارسال مجدد کد' }</p>
                    </button>

                    <button onClick={ handleSubmit }>
                        <h3>{actionType === "sign-in" ? "ایجاد حساب" : "ورود به حساب"}</h3>
                    </button>
                </div>
            </div>

            <div className="row">
                <div className="col-12" id={ Styled.GuidTextFrame }>
                    <p>جهت تکمیل مراحل ایجاد حساب کاربری. لطفا کد ارسال شده به تلفن همراه خود را وارد کنید.</p>
                </div>
            </div>

            <MenuBar />
        </>
    );
}

export default CodeReceive;
